module.exports = __webpack_public_path__ + "static/media/stories-icon.8e3298d5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-stories/stories-icon.png
 ** module id = 2604
 ** module chunks = 0
 **/